module.exports = __webpack_public_path__ + "static/media/bg-dashboard.f1fd5280.png";